<mat-toolbar>
  <img class="logo" alt="xatena logo" src="./assets/images/logo-xatena-gold.png" />
  @if ((isAuthenticated | async) === false) {
    <section class="action-bar">
      <a mat-flat-button [routerLink]="['/account/login']" routerLinkActive="hide-if-active"
        ><mat-icon>arrow_back</mat-icon> {{ 'NAVIGATION.ACTION.LOGIN.LABEL' | translate }}
      </a>
    </section>
  }
  @if (isAuthenticated | async) {
    <section class="action-bar">
      <a mat-icon-button [routerLink]="['/home']" routerLinkActive="active" [matTooltip]="'NAVIGATION.ACTION.COCKPIT.TOOLTIP' | translate"
        ><mat-icon>home</mat-icon></a
      >
    </section>
  }
  <!-- Comment Search out, not working / @2dm 07.10.24 -->
  <!-- <section class="search" *ngIf="isAuthenticated | async">
    <form [formGroup]="catalogSearchForm">
      <mat-form-field appearance="outline">
        <input matInput formControlName="searchText" [placeholder]="'NAVIGATION.SEARCH.INPUT.PLACEHOLDER' | translate" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </form>
  </section> -->
  @if (appName) {
    <section class="env-indicator" [style.background-color]="appNameColor">
      {{ appName }}
    </section>
  }
  <span class="spacer"></span>
  <section class="links">
    <a target="_blank" href="assets\docs\Xatena_AGB_2_11_01_01_20.pdf">{{ 'NAVIGATION.LINKS.AGB' | translate }}</a>
    |
    <a target="_blank" href="assets\docs\Xatena_Datenschutzerklaerung_01-09-23.pdf">{{ 'NAVIGATION.LINKS.GDPR' | translate }}</a>
    |
    <a target="_blank" href="https://www.xatena.com/impressum">{{ 'NAVIGATION.LINKS.IMPRINT' | translate }}</a>
  </section>
  @if (isAuthenticated | async) {
    <section class="user-options">
      <button mat-button [matMenuTriggerFor]="userMenu">
        <mat-icon class="me-1">account_circle</mat-icon>
        @if (userInfo | async; as userInfo) {
          <span> {{ userInfo.firstName }} {{ userInfo.lastName }}</span>
        }
      </button>
      <mat-menu #userMenu="matMenu" xPosition="before">
        <button mat-menu-item [routerLink]="[accountRouteNames.ModuleBase, accountRouteNames.UserProfile]">
          <mat-icon>account_circle</mat-icon>
          {{ 'NAVIGATION.USER_OPTIONS.PROFILE.LABEL' | translate }}
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="onLogout()">
          <mat-icon>logout</mat-icon>{{ 'NAVIGATION.USER_OPTIONS.LOGOUT.LABEL' | translate }}
        </button>
      </mat-menu>
      <a mat-button [routerLink]="['/help']" routerLinkActive="active">
        <mat-icon class="me-1">help</mat-icon>
        <span>{{ 'NAVIGATION.ACTION.HELP.TOOLTIP' | translate }}</span>
      </a>
    </section>
  }
  <section class="languages">
    <app-language-select></app-language-select>
  </section>
</mat-toolbar>
<app-breadcrumb [class.show]="isAuthenticated | async"></app-breadcrumb>
<mat-progress-bar color="accent" mode="determinate" [value]="loader.value$ | async"></mat-progress-bar>
